<template>
  <div id="app">
    <van-nav-bar
      :title="$route.meta.title"
      v-show="!$route.meta.noshowback"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <router-view />

    <van-tabbar
      v-if="!$route.meta.nobottombar"
      v-model="active"
      @change="onChange"
    >
      <van-tabbar-item icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item icon="friends-o">个人中心</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { BzUser } from "@/modules/js/helper";
export default {
  name: "App",
  data() {
    return {
      active: 0,
    };
  },
  methods: {
    onChange() {
      if (this.active == 0) {
        var user = BzUser.get();
        if (user.IsStore == 0) this.$router.push("/home");
        else this.$router.push("/monitorlist/0/" + user.IsStore + "/0");
      } else if (this.active == 1) {
        this.$router.push("/usercenter");
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue